// extracted by mini-css-extract-plugin
export default {"details__title":"EnterDetailsStep_details__title__vxUZo","packageDetails__title":"EnterDetailsStep_packageDetails__title__5i8Jl"};